import React, { useState } from "react";
import useAddRfid from "../../hooks/useAddRfid";

export default function AddRfidModal({ isOpen, onClose, onSuccess }) {
  const { addRfid, isLoading, error } = useAddRfid();

  const [formData, setFormData] = useState({
    group_id: "",
    phone: "",
    rfid: "",
    expiry_date: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addRfid(formData);
      setFormData({
        group_id: "",
        phone: "",
        rfid: "",
        expiry_date: "",
      });
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-light mb-4">Add New RFID</h2>

        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Group ID *
            </label>
            <input
              type="text"
              required
              value={formData.group_id}
              onChange={(e) => handleChange("group_id", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Phone *
            </label>
            <input
              type="tel"
              required
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              RFID *
            </label>
            <input
              type="text"
              required
              value={formData.rfid}
              onChange={(e) => handleChange("rfid", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Expiry Date (optional)
            </label>
            <input
              type="date"
              value={formData.expiry_date}
              onChange={(e) => handleChange("expiry_date", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-neutral-300 rounded hover:bg-neutral-50 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 px-4 py-2 bg-neutral-900 text-white rounded hover:bg-neutral-800 transition disabled:opacity-50"
            >
              {isLoading ? "Adding..." : "Add RFID"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}